@if (visible()) {
  <output class="shell-coupon-banner">
    <p class="shell-coupon-banner__message">{{ 'layout.coupon.message' | translate }}</p>
  </output>
}
